interface ILogContent {
  icon?: string;
  title?: string;
  body: any;
}

const LOGGER_KEY = "WIENI_LOGS";

/*
  Logger Service to log events and information to the console.
  - By default logs are enables on development and disabled on production
  - Logs can be enabled/disabled by setting the "WIENI_LOGS" to true/false in local storage
*/
class LoggerService {
  constructor() {
    if (process.env.REACT_APP_ENV !== "production") {
      console.log(
        `👩‍💻 Hi, welcome to Wieni logger for Tourmanagement.\n To see the logs, set ${LOGGER_KEY}=true in your local storage.`
      );

      // Only set "WIENI_LOGS" to true in local storage if the value is not yet set
      const value = LoggerService.getLoggerKey();
      if (!value) {
        this.enableLogs();
      }
    }
  }

  private enableLogs(): void {
    window.localStorage.setItem(LOGGER_KEY, "true");
  }

  private static getLoggerKey(): string | null {
    const value = localStorage.getItem(LOGGER_KEY);
    return value;
  }

  // Check if "WIENI_LOGS" is set to true in local storage
  private logsEnabled(): boolean {
    const value = LoggerService.getLoggerKey();
    return value && JSON.parse(value);
  }

  // Always use this method to log events or information to the console
  log({ icon, title, body }: ILogContent): void {
    if (this.logsEnabled()) {
      console.group(icon, title);
      console.log(body);
      console.groupEnd();
    }
  }
}

// Make sure only one instance of LoggerService is created
const loggerService = new LoggerService();
Object.freeze(loggerService);

export { loggerService };
